import { DOSSIER_TYPE_LABELS } from "./dossierLabels";

/** Types de dossier affichés dans Budget (tarifs par partenaire × région). Exclut le legacy `led`. */
export const BUDGET_DOSSIER_TYPE_VALUES = [
  "led_exterieur",
  "led_interieur",
  "deshumidificateur",
  "vmc_agricoles",
  "th_122",
  "renovation",
  "hp_bp_flottante",
  "pac",
] as const;

export type BudgetDossierTypeValue = (typeof BUDGET_DOSSIER_TYPE_VALUES)[number];

/** Libellés exacts des références stock créées pour le catalogue budget. */
export const BUDGET_TYPE_CATALOG_NAMES: string[] = BUDGET_DOSSIER_TYPE_VALUES.map(
  (value) => DOSSIER_TYPE_LABELS[value]
);

const catalogNameSet = new Set(BUDGET_TYPE_CATALOG_NAMES);

export function isBudgetCatalogName(name: string): boolean {
  return catalogNameSet.has(name);
}

/** Ordre d’affichage : types catalogue d’abord (ordre métier), puis autres références. */
export function sortBudgetStockItems<T extends { name: string }>(items: T[]): T[] {
  const order = new Map(BUDGET_TYPE_CATALOG_NAMES.map((name, index) => [name, index]));
  return [...items].sort((a, b) => {
    const ai = order.has(a.name) ? order.get(a.name)! : 1000;
    const bi = order.has(b.name) ? order.get(b.name)! : 1000;
    if (ai !== bi) return ai - bi;
    return a.name.localeCompare(b.name, "fr");
  });
}
